import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, KnowledgeBaseItemSchema, KnowledgeBaseSchema } from "schema"
import { z } from "zod"
import { knowledgeBaseQuery } from "../lib/knowledgeBaseQuery"

type Response = DataResponse<z.infer<typeof KnowledgeBaseSchema>>

export function useDeleteKnowledgeBaseMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id }: { id: string }) => {
      const response = await axios.delete<Response>(`/knowledgeBase/${id}`)

      return response.data.data
    },
    onSuccess: (_, variables) => {
      // Update cache directly instead of invalidating to avoid refetch
      queryClient.setQueriesData(
        { queryKey: [knowledgeBaseQuery().queryKey.at(0)] },
        (oldData: z.infer<typeof KnowledgeBaseItemSchema>[] | undefined) => {
          if (!oldData) return oldData
          return oldData.filter((item) => item.id.toString() !== variables.id)
        },
      )
    },
  })
}
